/* eslint-disable sonarjs/no-collapsible-if */
import * as Yup from "yup";

import { Cart, CoopMembership } from "Store/cart/cartInterfaces";
import {
  Partner,
  PartnerPayload,
  akademikernePartners,
} from "Store/partners/partnerInterfaces";
import {
  isAkademikerneAgreementCode,
  isAkademikerneCart,
  isCoopCart,
  isHuseierneAgreementCode,
  isHuseierneCart,
} from "Utils/cartUtils";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import {
  isAkademikerneSpecificProduct,
  isHuseierneSpecificProduct,
} from "./productUtils";

const getBrandingThemeFromGrp = (grp: string): Partner => {
  switch (grp) {
    case Partner.AFAG:
      return Partner.AFAG;
    case Partner.LEGEFORENINGEN:
      return Partner.LEGEFORENINGEN;
    case Partner.TANNLEGEFORENINGEN:
      return Partner.TANNLEGEFORENINGEN;
    case Partner.VETERINARENE:
      return Partner.VETERINARENE;
    case Partner.ECONA:
      return Partner.ECONA;
    case Partner.NATURVITERNE:
      return Partner.NATURVITERNE;
    case Partner.LEKTORLAGET:
      return Partner.LEKTORLAGET;
    case Partner.PSYKOLOGFORENINGEN:
      return Partner.PSYKOLOGFORENINGEN;
    case Partner.SAMFUNNSOKONOMENE:
      return Partner.SAMFUNNSOKONOMENE;
    case Partner.SAMFUNNSVITERNE:
      return Partner.SAMFUNNSVITERNE;
    case Partner.COOP:
      return Partner.COOP;
    case Partner.DANSKE_BANK:
      return Partner.DANSKE_BANK;
    case Partner.HUSEIERNE:
      return Partner.HUSEIERNE;
    default:
      return Partner.STOREBRAND;
  }
};

export const getPartnerPayloadFromGrp = (grp: string): PartnerPayload => {
  const partnerId = getBrandingThemeFromGrp(grp);
  const brandingTheme = getBrandingThemeFromGrp(grp);

  return { partnerId, brandingTheme };
};

export const findCoopMembership = (
  allMemberships?: CoopMembership[],
  id?: string,
): CoopMembership | undefined =>
  allMemberships?.find((membership) => membership.id === id);

interface PartnerSchema {
  partner: Partner | Partner[];
  schema: Yup.ObjectSchema<any>;
}

export const concatPartnerValidation = (
  brandingThemeId: Partner,
  validationSchema: Yup.ObjectSchema<any>,
  partnerSchemas: PartnerSchema[],
  cart: Cart | null,
): string | any => {
  let valSchema = validationSchema;

  partnerSchemas.forEach((el) => {
    if (el.partner === akademikernePartners) {
      if (
        akademikernePartners.includes(brandingThemeId) &&
        isAkademikerneCart(cart)
      ) {
        valSchema = valSchema.concat(el.schema);
      }
    }
    // eslint-disable-next-line sonarjs/no-redundant-boolean
    if (el.partner === Partner.COOP && false) {
      //TODO Coop branding: Turn off pending decision on membership check
      if (brandingThemeId === Partner.COOP && isCoopCart(cart)) {
        valSchema = valSchema.concat(el.schema);
      }
    }

    if (el.partner === Partner.HUSEIERNE) {
      if (brandingThemeId === Partner.HUSEIERNE && isHuseierneCart(cart)) {
        valSchema = valSchema.concat(el.schema);
      }
    }
  });
  return valSchema;
};

export const isAkademikerneTheme = (brandingThemeId: Partner): boolean => {
  return akademikernePartners.includes(brandingThemeId);
};

export const hasSpecifiedPartnerProductAndAgreementCodeMismatch = (
  productBackendName: ProductBackendName,
  agreementNumber: number | undefined,
): boolean => {
  const isHuseierneMismatch =
    isHuseierneSpecificProduct(productBackendName) &&
    !isHuseierneAgreementCode(agreementNumber);

  const isAkademikerneMismatch =
    isAkademikerneSpecificProduct(productBackendName) &&
    !isAkademikerneAgreementCode(agreementNumber);

  return isHuseierneMismatch || isAkademikerneMismatch;
};
